module.exports = {
  'WECHAT_FRIENDS':0,
  'WECHAT_TIMELINE': 1,
  'QQ': 2,
  'SMS': 3,
  'WEIBO': 4,
  'QZONE': 5,
  'EMAIL': 6,
  'COPY': 7
};


//////////////////
// WEBPACK FOOTER
// ./~/@dp/knb/compiled/dpapp/share.js
// module id = 515
// module chunks = 0